import script from "./TreeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeSelector.vue?vue&type=script&setup=true&lang=js"

import "./TreeSelector.vue?vue&type=style&index=0&id=5ec7a9ca&lang=css"

const __exports__ = script;

export default __exports__